import React, { useState } from 'react';
import cn from 'classnames';
import { TABS } from '../constansts';
import { UsedReceipeSemi } from './UsedReceipeSemi';
import { UsedReceipeGoods } from './UsedReceipeGoods';

export function Tabs() {
    const [activeTab, setTab] = useState(TABS[0].key);

    const setActiveTab = (key) => () => {
        if (key !== activeTab) setTab(key);
    };

    const renderTabContent = () => {
            switch (activeTab) {
                case 'goods': return <UsedReceipeGoods />;
                case 'semi': return <UsedReceipeSemi />;
                default: return null;
            }
        }
    

    return (
        <div className="kt-portlet kt-portlet--tabs">
            <div className="kt-portlet__head">
                <div className="kt-portlet__head-toolbar">
                    <ul className="nav nav-tabs nav-tabs-space-lg nav-tabs-line nav-tabs-bold nav-tabs-line-3x nav-tabs-line-brand">
                        {TABS.map((item) => (
                            <li key={item.key} className="nav-item">
                                <button onClick={setActiveTab(item.key)} className={cn("nav-link", { active: item.key === activeTab })}> <i className={item.icon}></i> {window.innerWidth > 400 ? item.title : item.title.slice(0,6) + '...'}</button>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="kt-portlet__body" style={{ minHeight: '350px', padding: 0 }}>
                <div className="tab-content">
                    {renderTabContent()}
                </div>
            </div>
            <div className="kt-portlet__foot">
                <div className="kt-form__actions kt-space-between">
                </div>
            </div>
        </div>
    );
}